import TomSelect from "tom-select";

document.addEventListener("turbo:load", function () {
  window.initializeTomSelects();
});

declare global {
  interface Window {
    initializeTomSelects: () => void;
  }
}

window.initializeTomSelects = function () {
  const selectElement = document.querySelector("#tom-select") as HTMLSelectElement;

  new TomSelect(selectElement, {
    plugins: {
      remove_button: {
        title: "Fjern"
      }
    },
    persist: false,
    maxOptions: undefined,
    create: false,
    maxItems: 1
  });

  const multiSelectElement = document.querySelector("#multi-tom-select") as HTMLSelectElement;

  new TomSelect(multiSelectElement, {
    plugins: {
      remove_button: {
        title: "Fjern"
      }
    },
    persist: false,
    maxOptions: undefined,
    create: false,
    maxItems: undefined
  });
};
